import { NmsWizardStepConverter, NmsWizardStepMapData } from "@nms-angular-toolkit/nms-wizard";
import { Injectable } from "@angular/core";
import { MuxDemuxDevicesModel, MuxDemuxInfoModel } from "../../../../mux-demux.model";

/**
 * Serviço responsável por converter os dados de @see DeviceLinkModel para @see GeneralLinkModel.
 */
@Injectable({
    providedIn: "root"
})
export class MuxDemuxDevicesTabConverter implements NmsWizardStepConverter<MuxDemuxInfoModel, MuxDemuxDevicesModel> {

    convert(muxinfoModel: MuxDemuxInfoModel, wizardStepsCacheMap: NmsWizardStepMapData): MuxDemuxDevicesModel {
        const model = new MuxDemuxDevicesModel();
        const muxdemuxDevicesModel = wizardStepsCacheMap["MuxDemuxDevicesModel"] as MuxDemuxDevicesModel || model;
        wizardStepsCacheMap["MuxDemuxInfoModel"] = muxinfoModel;

        return muxdemuxDevicesModel;
    }
}
